import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { Reveal, SectionLabel } from "./Reveal";
import { LogoMark } from "./Logo";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" className="relative py-28 md:py-40" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-7">
          <SectionLabel n="01">{a.label}</SectionLabel>
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl leading-[1.08] mt-8 text-[var(--text)]" data-testid="about-title">
              {a.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 text-base md:text-lg text-[var(--text)]/80 leading-relaxed max-w-2xl">{a.p1}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 font-serif-accent text-xl md:text-2xl text-[var(--gold)] max-w-2xl leading-snug">«{a.p2}»</p>
          </Reveal>
          <div className="mt-14 grid sm:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden">
            {a.facts.map((f, i) => (
              <Reveal key={i} delay={0.1 * i} y={20} className="bg-[var(--bg)] p-6">
                <div className="text-xs uppercase tracking-[0.2em] text-[var(--muted)]">{f.k}</div>
                <div className="mt-3 text-[var(--text)] font-semibold" data-testid={`about-fact-${i}`}>{f.v}</div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 lg:pl-10">
          <motion.div
            initial={{ opacity: 0, y: 60, rotate: -2 }}
            whileInView={{ opacity: 1, y: 0, rotate: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
            className="relative rounded-[28px] overflow-hidden border border-white/10 bg-[var(--surface)] lg:sticky lg:top-28"
            data-testid="director-card"
          >
            <div className="relative">
            <div className="relative h-64 md:h-72 overflow-hidden">
              <img loading="lazy" decoding="async" src="/assets/about-caspian.webp" alt="Каспий, Актау" className="w-full h-full object-cover opacity-80 kenburns kb-b" />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent,var(--surface))]" />
            </div>
              <div className="absolute left-6 bottom-0 translate-y-1/2 w-24 h-24 rounded-full bg-[var(--bg)] border border-[var(--gold)]/50 grid place-items-center text-[var(--text)]">
                <LogoMark className="w-[84px] h-[84px]" />
              </div>
            </div>
            <div className="p-6 md:p-8 pt-16 md:pt-20">
              <div className="text-xs uppercase tracking-[0.3em] text-[var(--gold)]">{a.director}</div>
              <div className="font-display text-2xl md:text-3xl mt-3 text-[var(--text)] leading-tight" data-testid="director-name">{a.name}</div>
              <div className="mt-3 text-sm text-[var(--muted)]">{a.role}</div>
              <div className="mt-8 pt-6 border-t border-white/10 grid gap-3 text-sm">
                <a href="tel:+77000222674" data-testid="director-phone-link" className="text-[var(--text)] hover:text-[var(--gold)] transition-colors">+7 700 022 26 74</a>
                <a href="mailto:toobaspanakurylys@bk.ru" data-testid="director-email-link" className="text-[var(--text)] hover:text-[var(--gold)] transition-colors break-all">toobaspanakurylys@bk.ru</a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
